import "bootstrap/dist/css/bootstrap.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Spinner } from "react-bootstrap";

import { AuthProvider, useAuth } from "./auth/AuthContext";
import LoginPage from "./auth/LoginPage";

import OpeningPage from "./components/OpeningPage";
import Technoparts from "./components/Technoparts";
import Amotive     from "./components/AmotiveTP";
import SudRicambi  from "./components/SudRicambi";
import Proforma    from "./components/Proforma";
import Esposizione from "./components/Esposizione";
import Ordini      from "./components/Ordini";
import Home      from "./components/home/Home";


import Contatti from "./components/utility/VediContatti";
import BackOrder from "./components/utility/BackOrder";
import AddContatto from "./components/utility/AddContatti";
import Ticket from "./components/utility/Ticket";
import Ritiri from "./components/utility/VediRitiri";

// ── Guard: mostra spinner → blocco IP → login → app ─────────────────────────
const AppRoutes = () => {
  const { checked, loggedIn, blockedIP } = useAuth();

  if (!checked) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#1a1a1a",
        }}
      >
        <Spinner animation="border" variant="light" />
      </div>
    );
  }

  if (blockedIP) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#1a1a1a",
          color: "#fff",
        }}
      >
        <h2>Accesso non consentito</h2>
        <p style={{ color: "#aaa" }}>Il tuo IP non è autorizzato.</p>
      </div>
    );
  }

  if (!loggedIn) return <LoginPage />;

  return (
    <Routes>
      //UTILITY
       <Route
        path="/utility/contatti"
        element={<Contatti />}
      />
       <Route
        path="/utility/backorder"
        element={<BackOrder />}
      />
       <Route
        path="/utility/add-contatti"
        element={<AddContatto />}
      />
       <Route
        path="/utility/ticket"
        element={<Ticket />}
      />
       <Route
        path="/utility/ritiri"
        element={<Ritiri />}
      />



      <Route path="/"               element={<OpeningPage />} />
      <Route path="/home"               element={<Home />} />
      <Route path="/technoparts"    element={<Technoparts />} />
      <Route path="/amotive"        element={<Amotive />} />
      <Route path="/sud-ricambi"    element={<SudRicambi />} />
      <Route path="/proforma"       element={<Proforma />} />
      <Route path="/esposizione"    element={<Esposizione />} />
      <Route path="/ordini-urgenti" element={<Ordini />} />
    </Routes>
  );
};

// ── Root ─────────────────────────────────────────────────────────────────────
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;